import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function UnpaidCustomer() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [networkName, setNetworkName] = useState([]);
    const [streetName, setStreetName] = useState([]);
    const [staffCode, setStaffCode] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ area_code: "", network: "", street: "" })
    const initialFormData = { area_code: "", network: "", street: "" }
    const [selectedIds, setSelectedIds] = useState([]);
const [sortKey, setSortKey] = useState("");
const [sortOrder, setSortOrder] = useState("asc");
const handleSort = (key) => {
  setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
  setSortKey(key);
};

    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  const downloadCSV = () => {
  const headers = [
    "Customer_Name", "Acc_no", "Code", "STB_no", "Door_no", "Flat_name",
    "Street_name", "Phone", "Pay_Status", "Plan_Amount", "Paid_Amount", "Paid_Date",
    "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
    "Staff_Code", "Network", "Paid_time", "Package", "Added_date", "Collection_Staff", "con status"
  ];

  const csvRows = [];
  csvRows.push(headers.join(",")); // header row

  allCustomer.forEach((row) => {
    const values = [
      row.name,
      row.account_num,
      row.acc_num,
      row.serial_num,
      row.doorno,
      row.flat_name,
      row.street,
      row.mobile,
      row.status,
      row.pay_amt,
      row.paid_amt,
      row.paid_date,
      row.balance_amt,
      row.discount,
      row.extra_balance_amt,
      row.pend_amt,
      row.area_code,
      row.net_name,
      row.paid_time,
      row.package,
      row.adate,
      row.col_boy,
        row.con_status
    ];

    // Properly escape and wrap every value
    const safeValues = values.map(v => {
      const str = v == null ? "" : String(v).replace(/"/g, '""'); // escape quotes
      return `"${str}"`; // wrap with double quotes
    });

    csvRows.push(safeValues.join(","));
  });

  const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "UnpaidCustomers.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
// 1. SEARCH (FULL DATA)
const filteredRows = allCustomer.filter(row =>
  Object.values(row).some(val =>
    String(val).toLowerCase().includes(searchQuery.toLowerCase())
  )
);

// 2. SORT (FULL DATA)
const sortedRows = [...filteredRows].sort((a, b) => {
  if (!sortKey) return 0;

  const A = a[sortKey] ?? "";
  const B = b[sortKey] ?? "";

  if (!isNaN(A) && !isNaN(B)) {
    return sortOrder === "asc" ? A - B : B - A;
  }

  return sortOrder === "asc"
    ? A.toString().localeCompare(B.toString())
    : B.toString().localeCompare(A.toString());
});

// 3. PAGINATION (AFTER SORT)
const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = sortedRows.slice(indexOfFirstRow, indexOfLastRow);

// 4. TOTAL PAGES
const totalPages = Math.ceil(sortedRows.length / rowsPerPage);

 
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    const handleClear = () => { setFormData(initialFormData); };
    
   const handleCheckboxChange = (id) => {
  setSelectedIds((prev) =>
    prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
  );
};

const handleSelectAll = (checked) => {
  if (checked) {
    // ✅ select all visible rows
    const allIds = filteredRows.map((row) => row.id);
    setSelectedIds(allIds);
  } else {
    // ✅ unselect all
    setSelectedIds([]);
  }
};

console.log(selectedIds); // shows all selected row IDs

    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); a();
        async function a() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/unpaidCustomerSpecific', { user, formData });
                if (response.status === 200) {
                    console.log(response.data.result);
                    setStbCount(response.data.result.length);
                    setAllCustomer(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    const handleDeactiveClick = async () => {
  try {
    const response = await axios.post(
      "https://node.cabletvpay.in/unpaidCustomerDeactive",
      { user, ids: selectedIds } // ✅ sending user + selected IDs
    );

    console.log("API Response:", response.data);
    alert(`Successfully deactivated ${selectedIds.length} customers!`);

    // ✅ clear selection after success
    setSelectedIds([]);
  } catch (error) {
    console.error("Error sending selected IDs:", error);
    alert("Something went wrong while deactivating.");
  }
};

    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/unpaidCustomerGetInfo', { user });
            if (response.status === 200) {
                setNetworkName(response.data.net_name);
                setStbCount(response.data.allCustomer.length);

                setStaffCode(response.data.staffCode);
                setStreetName(response.data.streetDetails);
                setAllCustomer(response.data.allCustomer);
            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return <div className='d-flex justify-content-center align-items-center min-vh-100'>Error: {error}</div>;
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <h5 className='h5'>UNPAID CUSTOMER DETAILS</h5><hr className='mt-0' />
                <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                <div className="border-0 px-1">
                    <form method="get" onSubmit={handleSubmit}>
                        <div className="row mx-3  d-flex justify-content-center">
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="area_code" className="text-center valuesDec text-navy">Staff Code</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="area_code" name="area_code" value={formData.area_code} onChange={handleChange}>
                                        <option className='bg-light' value="">none</option>
                                        {staffCode.length > 0 ? (staffCode.map((row, index) => (
                                            <option className='bg-light' key={index} value={row.name + "-" + row.staffCode}>
                                                {row.name} - ({row.staffCode})
                                            </option>
                                        ))) : (<option className='bg-light' value="">No staff codes available</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="network" className="text-center valuesDec text-navy">Network Name</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="network" name="network" value={formData.network} onChange={handleChange}>
                                        <option className='bg-light' value="none">none</option>
                                        {networkName.length > 0 ? (networkName.map((row, index) => (
                                            <option className='bg-light' key={index} value={row.network}>
                                                {row.network}
                                            </option>
                                        ))) : (<option className='bg-light' value="">No staff codes available</option>)}
                                    </select>
                                </div></div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="street" className="text-center valuesDec text-navy">Street Name</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="street" name="street" value={formData.street} onChange={handleChange}>
                                        <option className='bg-light' value="none">none</option>
                                        {streetName.length > 0 ? (
                                            streetName.map((row, index) => (
                                                <option className='bg-light' key={index} value={row.street_name}>
                                                    {row.street_name}
                                                </option>
                                            ))
                                        ) : (
                                            <option className='bg-light' value="">No staff codes available</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                                <input type="submit" className="btn border-0 h-75 bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                            </div>
                            <div className="col-lg-1 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                                <button type="button" className="btn border-0 bg-danger filterBtn text-light h-75 pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                            </div>
                        </div>
                    </form></div>
                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-1">
                                <span><div className="row w-auto">
                                    <div className="col-11 col-lg-3">
                                        <div className="d-flex">
                                            <button
                                            className="btn btn-danger w-75"
                                            style={{ borderRadius: "5px" }}
                                            onClick={handleDeactiveClick}
                                            disabled={selectedIds.length === 0}
                                            >
                                            <i className="fas fa-user-slash me-2"></i>
                                            Deactive ({selectedIds.length})
                                            </button>


                                        </div>
                                    </div>

                                    <div className="col-11 col-lg-3">
                                        <div className="input-group">
                                            <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                            <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                        <div className="d-flex justify-content-end">
                                            <div className=" btn-group">
                                                <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                 <button type="button" className="btn btn-dark border-left px-lg-3 px-5 my-1 d-flex" data-toggle="modal" onClick={handleCopyToClipboard} data-target="#exampleModal"> <i className="far fa-copy pt-1 px-1" /> STBCOPY-{stbCount} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div></span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                                  <table
  id="myTable"
  className="table table-bordered table-dark table-responsive"
>                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>
                                    <th>Status</th>
                                 <th className="text-center">
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.length === filteredRows.length && filteredRows.length > 0}
                                                onChange={(e) => handleSelectAll(e.target.checked)}
                                            /> 
                                            Deactive
                                            </th>
                                    <th>Payment</th>
                                    <th>Edit </th>
                                    <th onClick={() => handleSort("name")}>Customer__Name</th>
                                     <th onClick={() => handleSort("mobile")}>Phone</th>
                                     <th onClick={() => handleSort("pay_amt")}>Plan Amount</th>
                                    <th onClick={() => handleSort("paid_amt")}>Paid Amount</th>
                                    <th onClick={() => handleSort("balance_amt")}>Balance Amount</th>
                                    <th onClick={() => handleSort("name")}>Discount Amount</th>
                                    <th onClick={() => handleSort("extra_balance_amt")}>Advance Amount</th>
                                    <th onClick={() => handleSort("pend_amt")}>Pending Amount</th>
                                    <th onClick={() => handleSort("account_num")}>Acc_no</th>
                                    <th onClick={() => handleSort("acc_num")}>Code</th>
                                    <th onClick={() => handleSort("serial_num")}>STB_no</th>
                                    <th onClick={() => handleSort("doorno")}>Door_no</th>
                                    <th onClick={() => handleSort("flat_name")}>Flat_name</th>
                                    <th onClick={() => handleSort("street")}>Street__name</th>
                                   
                                    <th onClick={() => handleSort("status")}>Pay Status</th>
                                   
                                    <th onClick={() => handleSort("area_code")}>Staff__Code</th>
                                    <th onClick={() => handleSort("net_name")}>Networks</th>

                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.length > 0 ? (currentRows.map((row, index) => (
                                    <tr key={index} className='text-dark' style={{ backgroundColor: row.status === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                         <td className='tableText text-bold'>{indexOfFirstRow + index + 1}</td>
                                        <td className='tableText text-bold'>
                                            {row.con_status === "active" || row.con_status === "Active" ? (
                                                <button className="btn btn-success">A</button>
                                            ) : row.con_status === "deactive" || row.con_status === "Deactive" ? (
                                                <div className="d-flex-column"><button className="btn btn-danger">D </button>{row.deactive_reason}</div>
                                            ) : (
                                                <div className="d-flex-column"><button className="btn btn-secondary">{row.con_status}</button>{row.deactive_reason}</div>
                                            )}
                                        </td>
                                       <td className="tableText text-bold text-center">
                                        <input
                                            type="checkbox"
                                            checked={selectedIds.includes(row.id)}   // controlled checkbox
                                            onChange={() => handleCheckboxChange(row.id)} // call handler
                                        />
                                        </td>
                      <td className='tableText py-lg-3'>
                       
                          <button
                            onClick={() => navigate(`/paymentPage/${row.id}`)}
                            className='btn btn-info elevation-2'
                          >
                            Pay
                          </button>
                       
                      </td>
                                        <td className='tableText text-bold'><div className="d-flex justify-content-center"><Link to="#"><button className="btn text-primary"><i className="fas fa-edit"></i></button></Link></div></td>
                                        <td className='tableText text-bold'>{row.name}</td>
                                          <td className='tableText text-bold'>{row.mobile}</td>
                                         <td className='tableText text-bold'>{row.pay_amt}</td>
                                        <td className='tableText text-bold'>{row.paid_amt}</td>
                                        <td className='tableText text-bold'>{row.balance_amt}</td>
                                        <td className='tableText text-bold'>{row.discount}</td>
                                        <td className='tableText text-bold'>{row.extra_balance_amt}</td>
                                        <td className='tableText text-bold'>{row.pend_amt}</td>
                                        <td className='tableText text-bold'>{row.account_num}</td>
                                        <td className='tableText text-bold'>{row.acc_num}</td>
                                        <td className='tableText text-bold'>{row.serial_num}</td>
                                        <td className='tableText text-bold'>{row.doorno}</td>
                                        <td className='tableText text-bold'>{row.flat_name}</td>
                                        <td className='tableText text-bold'>{row.street}</td>
                                      
                                        <td className='tableText text-bold'>{row.status}</td>
                                       
                                        <td className='tableText text-bold'>{row.area_code}</td>
                                        <td className='tableText text-bold'>{row.net_name}</td>

                                    </tr>
                                ))) : (<tr><td colSpan="10">No results found</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <div className="pagination btn-group">
                        <button className="btn bg-navy border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward"></i></button>
                        <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-navy" : "btn-outline-secondary"} border-left`} > 1 </button>
                        {currentPage > 3 && <span className="mx-1">...</span>}
                        {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i).filter((page) => page > 1 && page < totalPages).map((page) => (<button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-navy" : "btn-outline-secondary"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>))}
                        {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                        {totalPages > 1 && (<button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-navy" : "btn-outline-secondary"} border-right`}>{totalPages}</button>)}
                        <button className="btn bg-navy  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} ><i className="fas fa-forward"></i></button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default UnpaidCustomer;
